export function ReviewPage() {
  return (
    <div>
      <h1 className="page-title">审核队列</h1>
      <p className="page-sub">新发布 / 更新的 skill 会进入此队列等待审核</p>

      <div
        className="card"
        style={{
          marginTop: 28,
          padding: "56px 24px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 40, marginBottom: 12 }}>🛡️</div>
        <div style={{ fontSize: 15, fontWeight: 500 }}>审核流程尚未启用</div>
        <p
          style={{
            fontSize: 13,
            color: "var(--text-muted)",
            maxWidth: 400,
            margin: "10px auto 0",
            lineHeight: 1.6,
          }}
        >
          当前所有 publisher 发布直接上架。开启审核后,
          community channel 的新版本需要 reviewer 通过才能对用户可见。
        </p>
      </div>
    </div>
  );
}
